export default {
  appName: 'Sample Business',
  login: 'Log in',
  logout: 'Log out',
  error: 'Error',
}
